var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack fa-1x"},[_c('i',{staticClass:"far fa-circle fa-stack-2x"}),_vm._v(" "),_c('strong',{staticClass:"fa-stack-1x circle-text"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }